export default {
  common: {
    // Keeping it in blank is ok
  }
};
